import { render } from "./subadministradores.vue?vue&type=template&id=7d4ebe2c"
import script from "./subadministradores.vue?vue&type=script&lang=js"
export * from "./subadministradores.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__